import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCourseLecturesAction } from "../../redux/actions/courseAction";
import restrict from "../../../src/assets/images/restricted-area.png";
// import { toast } from "react-hot-toast";
const CoursePage = () => {
  const [lecturenumber, setLectureNumber] = useState(0);
  const { courses, error, lectures,loading } = useSelector((state) => state.courses);

  const [courseDetails, setCourseDetails] = useState();

  const courseid = useParams();

  const onselected = " text-brand_yellow font-semibold";

  const id = courseid.id;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCourseLecturesAction(id));

    setCourseDetails(courses?.filter((item) => item._id === id));
  }, [dispatch, id, courses]);

  return (
    <>
      {error ? (
        <div className="bg-brand_nero flex flex-col justify-center items-center h-[800px] py-24 my-auto text-white  w-full">
          <div className="bg-brand_jaguar h-[400px] lg:px-24 mx-6 flex flex-col justify-center text-center items-center lg:w-[600px]">
            <img src={restrict} width={"60px"} alt="" />
            <h1 className="text-xl my-4">Oops !!! Someting went wrong.</h1>
            <h1 className="lg:text-2xl my-3 text-white">{error}</h1>
            <h1 className="my-8">
              Visit the{" "}
              <Link to="/" className="text-brand_yellow">
                Home page
              </Link>{" "}
              or{" "}
              <Link to="/pricing" className="text-brand_yellow">
                Subscribe
              </Link>{" "}
              to access contents
            </h1>
          </div>
        </div>
      ) : (
        <div className="bg-brand_nero px-6 h-[750px] text-white">
          <div className="py-8 ml-20 lg:mx-24">
            {courseDetails ? (
              <h1 className="text-xl font-bold">{courseDetails[0]?.title}</h1>
            ) : (
              <h1 className="text-xl font-bold">Welcome!</h1>
            )}
          </div>

          { loading ? <h1>loading</h1> : 
           <div>
            <div className="grid grid-cols-3">
            <div className="col-span-3 lg:col-span-2">
              <video
                className="w-full rounded-md"
                src={lectures && lectures[lecturenumber]?.video?.url}
                autoPlay={true}
                controls
                disablePictureInPicture
                controlsList="nodownload  noremoteplayback"
              ></video>
            </div>
            <div className=" col-span-3 lg:col-span-1 px-4">
              <h1 className="text-center text-lg my-2">Syllabus</h1>

              {lectures?.map((item, index) => (
                <div
                  className="border-b-2 border-gray-400 justify-center text-center"
                  key={item._id}
                >
                  <button
                    onClick={() => {
                      setLectureNumber(index);
                    }}
                    className={`${
                      index === lecturenumber ? onselected : "text-gray-400"
                    }`}
                  >
                    <h1 className="my-4">
                      {" "}
                      #{index + 1} {item.title}
                    </h1>
                  </button>
                </div>
              ))}
            </div>
          </div>
         
          <div className="px-6">
            <h1 className="my-2 hidden md:block text-lg text-brand_yellow">
              {" "}
              {`#${lecturenumber + 1} ${
                lectures && lectures[lecturenumber]?.title
              } `}{" "}
            </h1>

            <h1 className="md:text-gray-400 py-8 text-brand_yellow">
              {" "}
              {lectures && lectures[lecturenumber]?.description}
            </h1>
          </div>
            </div> 
           }
           
        </div>
      )}
    </>
  );
};

export default CoursePage;
